import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';
import { AccountType } from '../../../shared/Constants';

const SurveysSideMenuBuilder = (accountId, accountType) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const buildSurveysTabs = () => {
    const listSurveys = {
      label: formatMessage(i18nMessages.listSurveys),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/surveys`;
        history.push(url);
      },
    };

    return listSurveys;
  };

  const buildSuperSurveyTabs = () => {
    const superSurveys = {
      label: formatMessage(i18nMessages.superSurveys),
      icon: 'pi pi-clone',
      items: [
        {
          label: formatMessage(i18nMessages.listSuperSurveys),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/survey-projects`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addSuperSurvey),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/survey-projects/new`;
            history.push(url);
          },
        },
      ],
    };

    return superSurveys;
  };

  const buildSurveyTemplateTabs = () => {
    const surveyTemplates = {
      label: formatMessage(i18nMessages.surveyTemplates),
      icon: 'pi pi-users',
      items: [
        {
          label: formatMessage(i18nMessages.listSurveyTemplates),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/surveys/templates`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addSurveyTemplate),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/surveys/templates/new`;
            history.push(url);
          },
        },
      ],
    };

    return surveyTemplates;
  };

  const buildExecutiveReportTabs = () => {
    const executiveReports = {
      label: formatMessage(i18nMessages.surveyAnalysis),
      icon: 'pi pi-calendar-plus',
      items: [
        {
          label: formatMessage(i18nMessages.listExecutiveReports),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/executive-reports`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addExecutiveReport),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/executive-reports/new`;
            history.push(url);
          },
        },
      ],
    };

    return executiveReports;
  };

  const buildSurveysMenu = () => {
    const surveyItems = [];

    const listSurveys = buildSurveysTabs();
    const superSurveys = buildSuperSurveyTabs();
    const surveyTemplates = buildSurveyTemplateTabs();
    const executiveReports = buildExecutiveReportTabs();

    if (accountType === AccountType.GSC || accountType === AccountType.GP) {
      surveyItems.push(listSurveys);
      surveyItems.push(surveyTemplates);
      surveyItems.push(executiveReports);
    } else {
      surveyItems.push(listSurveys);
      surveyItems.push(superSurveys);
      surveyItems.push(surveyTemplates);
      surveyItems.push(executiveReports);
    }

    const surveys = {
      label: formatMessage(i18nMessages.surveys),
      icon: 'pi pi-users',
      items: surveyItems,
    };

    return surveys;
  };

  return {
    buildSurveysMenu,
  };
};

export default SurveysSideMenuBuilder;
